import { render, staticRenderFns } from "./CompanyRiskEvent.vue?vue&type=template&id=601d010a&scoped=true&"
import script from "./CompanyRiskEvent.vue?vue&type=script&lang=js&"
export * from "./CompanyRiskEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d010a",
  null
  
)

export default component.exports